/**
 * @generated SignedSource<<7a51f5d6130d9e5db0cfafdacc571adf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TxnCounterpartLinkInputObject = {
  counterpartTxnId: string;
  txnId: string;
};
export type needsReviewPage_TxnCounterpartLinkMutation$variables = {
  input: TxnCounterpartLinkInputObject;
};
export type needsReviewPage_TxnCounterpartLinkMutation$data = {
  readonly txnCounterpartLink: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly updatedCount: number;
  } | null | undefined;
};
export type needsReviewPage_TxnCounterpartLinkMutation = {
  response: needsReviewPage_TxnCounterpartLinkMutation$data;
  variables: needsReviewPage_TxnCounterpartLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "needsReviewPage_TxnCounterpartLinkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TxnCounterpartLinkMutationPayload",
        "kind": "LinkedField",
        "name": "txnCounterpartLink",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "needsReviewPage_TxnCounterpartLinkMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TxnCounterpartLinkMutationPayload",
        "kind": "LinkedField",
        "name": "txnCounterpartLink",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "24dc96c71dea48e27b78e479fd902238",
    "id": null,
    "metadata": {},
    "name": "needsReviewPage_TxnCounterpartLinkMutation",
    "operationKind": "mutation",
    "text": "mutation needsReviewPage_TxnCounterpartLinkMutation(\n  $input: TxnCounterpartLinkInputObject!\n) {\n  txnCounterpartLink(input: $input) {\n    updatedCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "af2982f8750a00b73ef626d2f6fcb331";

export default node;
